// Función auxiliar debounce
function debounce(fn, delay) {
  let timer;
  return function(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

class ShippingProgressBar extends HTMLElement {
  constructor() {
    super();
    this.updateTimeout = null;
    this.init();
  }

  init() {
    this.updateMessage();
    
    // Aumentar el debounce a 500ms para dar más tiempo a los descuentos
    this.debouncedUpdate = debounce(() => this.updateMessage(), 500);
    
    // Escuchar cambios en el carrito con debounce
    document.addEventListener('cart:updated', () => this.debouncedUpdate());
    
    // Para Dawn theme específicamente
    if (typeof Shopify !== 'undefined' && Shopify.theme) {
      document.addEventListener('cart:refresh', () => this.debouncedUpdate());
    }
  }

  async updateMessage() {
    try {
      // Obtener carrito actualizado desde la API
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Detectar si hay descuentos aplicados o en proceso
      const hasDiscounts = cart.total_discount > 0 || 
                          (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0);
      
      // Si hay descuentos, esperar más tiempo para asegurar que se han aplicado completamente
      if (hasDiscounts) {
        await new Promise(resolve => setTimeout(resolve, 400));
        
        // Volver a obtener el carrito después del delay adicional
        const retryResponse = await fetch('/cart.js');
        const retryCart = await retryResponse.json();
        
        // Usar el carrito actualizado
        this.displayMessage(retryCart);
      } else {
        // Sin descuentos, delay normal más corto
        await new Promise(resolve => setTimeout(resolve, 200));
        this.displayMessage(cart);
      }
      
    } catch (error) {
      console.error('Error updating shipping message:', error);
    }
  }

  displayMessage(cart) {
    // El total viene en centavos, convertir a euros
    const total = cart.total_price / 100;
    const messageEl = document.getElementById('shipping-message');
    
    if (!messageEl) return;

    // Actualizar el data attribute para mantener consistencia
    messageEl.dataset.cartTotal = total;

    // Calcular y mostrar mensaje apropiado
    if (total === 0) {
      messageEl.textContent = messageEl.dataset.emptyMessage || 'Envíos gratis gastando más de 50 euros';
    } else if (total < 50) {
      const remaining = (50 - total).toFixed(2);
      messageEl.textContent = messageEl.dataset.tier2Message?.replace('{{ amount }}', remaining) 
        || `Añade ${remaining} € para envío gratis`;
    } else {
      messageEl.textContent = messageEl.dataset.freeMessage || '¡Tu envío es gratis!';
    }
  }
}

// Registrar el web component si no existe
if (!customElements.get('shipping-progress-bar')) {
  customElements.define('shipping-progress-bar', ShippingProgressBar);
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  const shippingBar = document.querySelector('shipping-progress-bar');
  if (shippingBar) {
    shippingBar.init();
  }
});
